module.exports = __webpack_public_path__ + "static/media/az.90a22aa7.webp";